import { MappedImage, VimeoFrame, ModalWrapper } from "../../utils/fw"

const dismissStyle = {
	height: "6%",
	left: "68%",
	top: "12%",
	width: "4%",
}
const dismissHTML = "X"

const modalOverrides = { dismissStyle, dismissHTML }

export default {
	background: "https://assets.swoogo.com/uploads/full/5403550-6838c7d68e76a.jpg",
	links: [
		{
			height: "31%",
			label: "Find out more about the services included in your ISF Membership",
			left: "10%",
			modal: <MappedImage
				imageURL="https://assets.swoogo.com/uploads/full/1410185-616860cce8c1e.png"
				links={[
					{
						gameRule: "explore-left-magazine-chapter",
						height: "5%",
						href: "https://assets.swoogo.com/uploads/1410556-61687712b4685.pdf",
						label: "ISF Chapter Programme 2022",
						left: "31%",
						target: "_blank",
						top: "19%",
						width: "40%",
					},
					{
						gameRule: "explore-left-magazine-work",
						height: "5%",
						href: "https://assets.swoogo.com/uploads/1410549-6168770ff1cbf.pdf",
						label: "ISF Forward Work Programme",
						left: "31%",
						target: "_blank",
						top: "25.3%",
						width: "40%",
					},
					{
						gameRule: "explore-left-magazine-learning",
						height: "5%",
						href: "https://assets.swoogo.com/uploads/1410555-616877116b35a.pdf",
						label: "ISF Learning",
						left: "31%",
						target: "_blank",
						top: "31.5%",
						width: "40%",
					},
					{
						gameRule: "explore-left-magazine-risk",
						height: "5%",
						href: "https://assets.swoogo.com/uploads/1410552-61687710a428c.pdf",
						label: "ISF Risk Transformation Programme",
						left: "31%",
						target: "_blank",
						top: "37.8%",
						width: "40%",
					},
					{
						gameRule: "explore-left-magazine-consult",
						height: "5%",
						href: "https://assets.swoogo.com/uploads/1410547-6168770d85188.pdf",
						label: "ISF Consultancy Services",
						left: "31%",
						target: "_blank",
						top: "44.1%",
						width: "40%",
					},
					{
						gameRule: "explore-left-magazine-value",
						height: "5%",
						href: "https://assets.swoogo.com/uploads/1410548-6168770e93074.pdf",
						label: "How the ISF delivers added value",
						left: "31%",
						target: "_blank",
						top: "50.3%",
						width: "40%",
					},
					{
						gameRule: "explore-left-magazine-membership",
						height: "5%",
						href: "https://assets.swoogo.com/uploads/1410551-616877109c467.pdf",
						label: "ISF Membership Benefits",
						left: "31%",
						target: "_blank",
						top: "56.6%",
						width: "40%",
					},
					{
						gameRule: "explore-left-magazine-reward",
						height: "5%",
						href: "https://assets.swoogo.com/uploads/1410550-61687710a2273.pdf",
						label: "ISF Membership Referrals Reward Programme",
						left: "31%",
						target: "_blank",
						top: "62.9%",
						width: "40%",
					},
					{
						gameRule: "explore-left-magazine-constitution",
						height: "5%",
						href: "https://assets.swoogo.com/uploads/1410554-61687710cf316.pdf",
						label: "ISF Constitution",
						left: "31%",
						target: "_blank",
						top: "69.1%",
						width: "40%",
					},
					{
						gameRule: "explore-left-magazine-code",
						height: "5%",
						href: "https://assets.swoogo.com/uploads/1410553-6168771093ef5.pdf",
						label: "ISF Member Code of Conduct",
						left: "31%",
						target: "_blank",
						top: "75.4%",
						width: "40%",
					},
					{
						gameRule: "explore-left-magazine-live",
						height: "4.9%",
						href: "https://www.isflive.org/s/communities",
						label: "Topical Communities",
						left: "35.7%",
						target: "_blank",
						top: "83.3%",
						width: "28.4%",
					},

				]}
			/>,
			modalOverrides,
			top: "54%",
			width: "8%",
		},
		{
			height: "31%",
			label: "The latest cyber security trends and how the ISF can help",
			left: "82%",
			modal: <MappedImage
				imageURL="https://assets.swoogo.com/uploads/full/1434367-617213fc6e5fe.png"
				links={[
					{
						gameRule: "explore-right-magazine-tools",
						width: "42.5%",
						height: "5.2%",
						left: "28.8%",
						top: "15.9%",
						href: "https://assets.swoogo.com/uploads/1412335-61698d4c82422.pdf",
						label: "ISF Aligned Tools Suite",
						target: "_blank",
					},
					{
						gameRule: "explore-right-magazine-cyber",
						width: "42.5%",
						height: "5.2%",
						left: "28.8%",
						top: "22.1%",
						href: "https://assets.swoogo.com/uploads/1412333-61698d4a715d1.pdf",
						label: "Remote Working and Cyber Risk",
						target: "_blank",
					},
					{
						gameRule: "explore-right-magazine-attack",
						width: "42.5%",
						height: "5.2%",
						left: "28.8%",
						top: "28.3%",
						href: "https://assets.swoogo.com/uploads/1412326-61698d4383005.pdf",
						label: "Be Ready for a Ransomware Attack",
						target: "_blank",
					},
					{
						gameRule: "explore-right-magazine-aware",
						width: "42.5%",
						height: "5.2%",
						left: "28.8%",
						top: "34.7%",
						href: "https://assets.swoogo.com/uploads/1412330-61698d45686f5.pdf",
						label: "Changing Behaviours with Cyber Security Awareness",
						target: "_blank",
					},
					{
						gameRule: "explore-right-magazine-shift",
						width: "42.5%",
						height: "5.2%",
						left: "28.8%",
						top: "40.9%",
						href: "https://assets.swoogo.com/uploads/1412327-61698d43abd95.pdf",
						label: "Managing Risk on Shifting Sands",
						target: "_blank",
					},
					{
						gameRule: "explore-right-magazine-supply",
						width: "42.5%",
						height: "5.2%",
						left: "28.8%",
						top: "47.2%",
						href: "https://assets.swoogo.com/uploads/1412332-61698d49eec75.pdf",
						label: "Securing your Supply Chain",
						target: "_blank",
					},
					{
						gameRule: "explore-right-magazine-railway",
						width: "42.5%",
						height: "5.2%",
						left: "28.8%",
						top: "53.4%",
						href: "https://assets.swoogo.com/uploads/1412331-61698d4887efd.pdf",
						label: "Securing European Railway Infrastructure",
						target: "_blank",
					},
					{
						gameRule: "explore-right-magazine-menace",
						width: "42.5%",
						height: "5.2%",
						left: "28.8%",
						top: "59.8%",
						href: "https://assets.swoogo.com/uploads/1412334-61698d4bd9748.pdf",
						label: "Understanding the Ransomware Menace",
						target: "_blank",
					},
					{
						gameRule: "explore-right-magazine-qira",
						width: "42.5%",
						height: "5.2%",
						left: "28.8%",
						top: "66.1%",
						href: "https://assets.swoogo.com/uploads/1412329-61698d443a4ec.pdf",
						label: "ISF Consultancy Services: QIRA",
						target: "_blank",
					},
					{
						gameRule: "explore-right-magazine-security",
						width: "42.5%",
						height: "5.2%",
						left: "28.8%",
						top: "72.4%",
						href: "https://assets.swoogo.com/uploads/1412325-61698d4329a27.pdf",
						label: "ISF Consultancy Services: Security Healthcheck",
						target: "_blank",
					},
					{
						gameRule: "explore-right-magazine-support",
						width: "42.5%",
						height: "5.2%",
						left: "28.8%",
						top: "78.7%",
						href: "https://assets.swoogo.com/uploads/1412328-61698d442b3e1.pdf",
						label: "ISF Consultancy Services: Controls, Policies and Standards support",
						target: "_blank",
					},
					{
						gameRule: "explore-right-magazine-live",
						width: "28.5%",
						height: "5.2%",
						left: "35.4%",
						top: "86.1%",
						href: "https://www.isflive.org/",
						label: "ISF Live",
						target: "_blank",
					},
				]}
			/>,
			modalOverrides,
			top: "54%",
			width: "8%",
		},
		{
			gameRule: "explore-e-learning",
			label: "Discover ISF e-learning by completing our 25 minute taster",
			width: "9.1%",
			height: "12.0%",
			left: "68.0%",
			top: "27.1%",
			modalOverrides: {
				dismissStyle: {
					height: "6%",
					left: "95%",
					top: "1%",
					width: "4%",
					color: "white",
					fontSize: "21px"
				},
				dismissHTML: "X"
			},
			modal: <ModalWrapper>
				<iframe style="width: 50vw; height: 80vh; border: none;" src="https://static1.tkevents.io/content-2-e-learning/index.html" />
			</ModalWrapper>
		},
		{
			label: "Discover how the  ISF can help support your risk transformation programme",
			width: "10.5%",
			height: "12.8%",
			left: "77.4%",
			top: "25.3%",
			modal: <VimeoFrame vidId="630878001?h=6b6c5ba33e&autoplay=1" />,
		},
		{
			height: "11%",
			label: "Cyber Awareness Month - Discover how the ISF can help you keep your organisation secure",
			left: "68%",
			modal: <VimeoFrame vidId="611706588?h=02f1d8939b&autoplay=1" />,
			top: "39%",
			width: "9%",
		},
		{
			height: "11.4%",
			label: "Dicover how the QIRA product suite can help you quantify risk",
			left: "22.6%",
			modal: <VimeoFrame vidId="637435441?h=fce80c465d&autoplay=1" />,
			top: "27.9%",
			width: "9%",
		},
		{
			height: "15%",
			label: "Quiz Hub - Participate in our surveys for a chance to win a prize and provide input into the ISF's programme of work",
			left: "31.6%",
			modal: <MappedImage imageURL="https://assets.swoogo.com/uploads/full/1410606-61687b8511af1.png" links={[
				{
					gameRule: "explore-quiz-work",
					height: "6%",
					href: "https://isfcongress.tkeventsregistration.com/ForwardWorkProgrammeSurvey",
					left: "29.9%",
					target: "_blank",
					top: "39.2%",
					width: "40%",
				},
				{
					gameRule: "explore-quiz-risk",
					height: "6%",
					href: "https://isfcongress.tkeventsregistration.com/ISFRiskPractitionerCapabilitySurvey",
					left: "29.9%",
					target: "_blank",
					top: "45.2%",
					width: "40%",
				},
				{
					gameRule: "explore-quiz-leadership",
					height: "6%",
					href: "https://isfcongress.tkeventsregistration.com/ISFSecurityLeadershipSurvey",
					left: "29.9%",
					target: "_blank",
					top: "51.5%",
					width: "40%",
				},
				{
					gameRule: "explore-quiz-supply",
					height: "6%",
					href: "https://isfcongress.tkeventsregistration.com/FeedbackFormISFSupplyChainWebApp",
					left: "29.9%",
					target: "_blank",
					top: "57.5%",
					width: "40%",
				},
			]}
			/>,
			modalOverrides: { dismissStyle: { right: "28.9%", top: "32.2%" } },
			top: "52.2%",
			width: "4.4%",
		},
		{
			label: "Chat With Us",
			width: "10.3%",
			height: "21.1%",
			left: "45.2%",
			top: "58.9%",
			CometChatID: "isf-exploration-zone"
		},
		{
			height: "15%",
			label: "Discover the ISF Podcast library",
			left: "64.8%",
			modal: <MappedImage imageURL="https://assets.swoogo.com/uploads/full/1428254-61707332606ea.png" links={[
				{
					label: "ISF podcast fact sheet 2021",
					height: "4.8%",
					href: "https://assets.swoogo.com/uploads/1411420-6168bfa7b2d4e.pdf",
					left: "59.4%",
					target: "_blank",
					top: "3%",
					width: "20%",
				},
				{
					height: "6.3%",
					href: "https://www.securityforum.org/spotlight-on/ai-automation-and-cyber-ethics-changing-the-game/",
					label: "Josh Jackson – AI, Automation, and Cyber Ethics: Changing the Game",
					left: "21.7%",
					target: "_blank",
					top: "9%",
					width: "57.7%",
				},
				{
					height: "6.3%",
					href: "https://www.securityforum.org/spotlight-on/you-are-what-you-risk/",
					label: "Michele Wucker – You Are What You Risk",
					left: "21.7%",
					target: "_blank",
					top: "15.6%",
					width: "57.7%",
				},
				{
					height: "6.3%",
					href: "https://www.securityforum.org/spotlight-on/influencing-security-behaviour/",
					label: "Dan Norman – Influencing Security Behaviour",
					left: "21.7%",
					target: "_blank",
					top: "22.2%",
					width: "57.7%",
				},
				{
					height: "6.3%",
					href: "https://www.securityforum.org/spotlight-on/generations-in-security/",
					label: "Mehak Vohra & Richard Guida – Generations in Security",
					left: "21.7%",
					target: "_blank",
					top: "28.8%",
					width: "57.7%",
				},
				{
					height: "6.3%",
					href: "https://www.securityforum.org/spotlight-on/exit-rich-the-6-p-method-to-sell-your-business/",
					label: "Michelle Seiler Tucker – Exit Rich: The 6P Method to Sell Your Business",
					left: "21.7%",
					target: "_blank",
					top: "35.4%",
					width: "57.7%",
				},
				{
					height: "6.3%",
					href: "https://www.securityforum.org/spotlight-on/training-for-digital-transformation/",
					label: "Thomas Erl – Training for Digital Transformation",
					left: "21.7%",
					target: "_blank",
					top: "41.9%",
					width: "57.7%",
				},
				{
					height: "6.3%",
					href: "https://www.securityforum.org/spotlight-on/remeasuring-values/",
					label: "Brigid Schulte – Remeasuring Values",
					left: "21.7%",
					target: "_blank",
					top: "48.5%",
					width: "57.7%",
				},
				{
					height: "6.3%",
					href: "https://www.securityforum.org/spotlight-on/how-to-reset-rethink-and-refocus/",
					label: "Kate Montague – How to Rethink, Reset, and Refocus",
					left: "21.7%",
					target: "_blank",
					top: "55.1%",
					width: "57.7%",
				},
				{
					height: "6.3%",
					href: "https://www.securityforum.org/spotlight-on/kate-stone-the-role-of-analogue-in-the-digital-age/",
					label: "Kate Stone – The Role of Analogue in the Digital Age",
					left: "21.7%",
					target: "_blank",
					top: "61.7%",
					width: "57.7%",
				},
				{
					height: "6.3%",
					href: "https://www.securityforum.org/spotlight-on/leadership-in-a-time-of-transition/",
					label: "Steve Durbin – Leadership in a Time of Transition",
					left: "21.7%",
					target: "_blank",
					top: "68.3%",
					width: "57.7%",
				},
				{
					height: "6.3%",
					href: "https://www.isflive.org/s/community-webcast/a2E6M000002Bo4hUAC/cyber-insurance-and-the-danger-of-silent-cyber",
					label: "Cyber Insurance and the danger of ‘Silent Cyber’ - Emma Mark Ward and Emma Bickerstaffe in conversation with Simon Meech, Cyber Practice Lead at insurance broker BMS Group.",
					left: "21.7%",
					target: "_blank",
					top: "74.9%",
					width: "57.7%",
				},
				{
					height: "8%",
					href: "https://www.isflive.org/s/community-webcast/a2E6M000002Bo6YUAS/is-zero-trust-right-for-you",
					label: "Is Zero Trust right for you?",
					left: "21.7%",
					target: "_blank",
					top: "81.4%",
					width: "57.7%",
				},
				{
					height: "6.3%",
					href: "https://www.isflive.org/s/community-webcast/a2E6M000002Bnv2UAC/securing-containers-with-people-process-and-technology",
					label: "Securing Containers with people, process and technology",
					left: "21.7%",
					target: "_blank",
					top: "89.7%",
					width: "57.7%",
				},
			]}
			/>,
			modalOverrides,
			top: "52.2%",
			width: "4.4%",
		},
		{

			height: "12.3%",
			label: "Give us your opinion on our research into upcoming threats",
			left: "11.8%",
			modal: <MappedImage imageURL="https://assets.swoogo.com/uploads/full/1436108-6172c89481208.png" links={[
				{
					gameRule: "explore-threat-crypto",
					height: "5.2%",
					left: "30.6%",
					onClick: () => document.getElementById("exploration-threat-crypto").click(),
					top: "26.8%",
					width: "40.1%",
				},
				{
					gameRule: "explore-threat-hack",
					height: "5.2%",
					left: "30.6%",
					onClick: () => document.getElementById("exploration-threat-hacktivists").click(),
					top: "33.1%",
					width: "40.1%",
				},
				{
					gameRule: "explore-threat-coding",
					height: "5.2%",
					left: "30.6%",
					onClick: () => document.getElementById("exploration-threat-coding").click(),
					top: "39.4%",
					width: "40.1%",
				},
				{
					gameRule: "explore-threat-data",
					height: "5.2%",
					left: "30.6%",
					onClick: () => document.getElementById("exploration-threat-biased").click(),
					top: "45.8%",
					width: "40.1%",
				},
				{
					gameRule: "explore-threat-ransoms",
					height: "5.2%",
					left: "30.6%",
					onClick: () => document.getElementById("exploration-threat-ransoms").click(),
					top: "52%",
					width: "40.1%",
				},
				{
					gameRule: "explore-threat-virtual",
					height: "5.2%",
					left: "30.6%",
					onClick: () => document.getElementById("exploration-threat-virtual").click(),
					top: "58.2%",
					width: "40.1%",
				},
				{
					gameRule: "explore-threat-cloudy",
					height: "5.2%",
					left: "30.6%",
					onClick: () => document.getElementById("exploration-threat-cloudy").click(),
					top: "64.4%",
					width: "40.1%",
				},
				{
					gameRule: "explore-threat-polluted",
					height: "5.2%",
					left: "30.6%",
					onClick: () => document.getElementById("exploration-threat-polluted").click(),
					top: "70.8%",
					width: "40.1%",
				},
				{
					gameRule: "explore-threat-soc",
					height: "5.2%",
					left: "30.6%",
					onClick: () => document.getElementById("exploration-threat-soc").click(),
					top: "77%",
					width: "40.1%",
				},
			]}
			/>,
			modalOverrides: {
				dismissStyle: {
					height: "6%",
					right: "28%",
					top: "16%",
					width: "4%",
				},
			},
			top: "38.4%",
			width: "10.7%",
		},
		{
			height: "11.3%",
			label: "ISF In Bitesize - A five minute introduction to the ISF Benchmark, IRAM 2 and Supply Chain",
			left: "22.8%",
			modal: <MappedImage imageURL="https://assets.swoogo.com/uploads/full/1434354-617212cb67deb.png" links={[
				{
					label: "Risk Assessment: How IRAM2 can help.",
					height: "5.4%",
					left: "28.3%",
					modal: <VimeoFrame vidId="623411017?h=643528d7c0&autoplay=1" />,
					target: "_blank",
					top: "42.6%",
					width: "43%",
				},
				{
					label: "Risk Assessment: Identify and action supply chain risk.",
					height: "5.4%",
					left: "28.3%",
					modal: <VimeoFrame vidId="623410183?h=d6c307c393&autoplay=1" />,
					target: "_blank",
					top: "49%",
					width: "43%",
				},
				{
					label: "Security Assurance: Benchmark in bitesize.",
					height: "5.4%",
					left: "28.3%",
					modal: <VimeoFrame vidId="623410559?h=b98de280dc&autoplay=1" />,
					target: "_blank",
					top: "55.2%",
					width: "43%",
				},
			]}
			/>,
			modalOverrides: {
				dismissStyle: {
					height: "7%",
					right: "27%",
					top: "34%",
					width: "5%",
				},
			},
			top: "39%",
			width: "8.7%",
		},
		{
			height: "38.0%",
			href: "/engagement-sessions",
			label: "ISF Engagement Sessions",
			left: "90.8%",
			top: "31.3%",
			width: "9.0%",
		},
		{
			height: "12.5%",
			label: "Discover more on ISF Live, the Member website",
			left: "77.3%",
			modal: <MappedImage imageURL="https://assets.swoogo.com/uploads/full/1411478-6168c3cbc8136.png" links={[
				{
					height: "4.3%",
					href: "https://www.isflive.org/s/isf-videos-podcasts",
					label: "Podcast",
					left: "18.3%",
					target: "_blank",
					top: "43%",
					width: "29.7%",
				},
				{
					height: "4.3%",
					href: "https://www.isflive.org/s/blog",
					label: "Blogs",
					left: "57.8%",
					target: "_blank",
					top: "43%",
					width: "29.7%",
				},
				{
					height: "4.3%",
					href: "https://www.isflive.org/s/communities",
					label: "Topical Communities",
					left: "18.3%",
					target: "_blank",
					top: "76.6%",
					width: "29.7%",
				},
				{
					height: "4.3%",
					href: "https://www.isflive.org/s/knowledge-library",
					label: "Library",
					left: "57.8%",
					target: "_blank",
					top: "76.6%",
					width: "29.7%",
				},
			]}
			/>,
			modalOverrides: {
				dismissStyle: {
					height: "6%",
					right: "10%",
					top: "15%",
					width: "4%",
				},
			},
			top: "38.5%",
			width: "10.9%",
		},
		{
			height: "34.8%",
			href: "/isf-speakers",
			label: "Who's Who",
			left: "0.0%",
			top: "34.8%",
			width: "9.0%",
		},
		{
			label: "Discover how the SOGP WebApp can help you",
			width: "10.8%",
			height: "12.3%",
			left: "11.7%",
			top: "25.5%",
			modal: <VimeoFrame vidId="637438659?h=94300269d4&autoplay=1" />
		},
		{
			height: "17.2%",
			label: "Recent releases - Access the latest ISF products",
			left: "32.3%",
			modal: <MappedImage imageURL="https://assets.swoogo.com/uploads/full/1411493-6168c5ec283aa.png" links={[
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/community-webcast/a2E6M000002Bo6YUAS/is-zero-trust-right-for-you",
					label: "Demystifying Zero Trust - Briefing Paper",
					left: "18.8%",
					target: "_blank",
					top: "15%",
					width: "60.7%",
				},
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/community-webcast/a2E6M000002Bo4hUAC/cyber-insurance-and-the-danger-of-silent-cyber",
					label: "Cyber Insurance: Is it worth the risk? - Briefing Paper",
					left: "18.8%",
					target: "_blank",
					top: "23.4%",
					width: "60.7%",
				},
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/article/Quantitative-Information-Risk-Assessment-QIRA-Methodology",
					label: "Quantitative Information Risk Assessment (QIRA) – Methodology",
					left: "18.8%",
					target: "_blank",
					top: "31.9%",
					width: "60.7%",
				},
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/community-webcast/a2E6M000002Bnv2UAC/securing-containers-with-people-process-and-technology",
					label: "Securing Containers: Keeping pace with change - Briefing Paper",
					left: "18.8%",
					target: "_blank",
					top: "40.3%",
					width: "60.7%",
				},
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/article/Security-Architecture-Navigating-complexity-Report",
					label: "Security Architecture: Navigating complexity - Report",
					left: "18.8%",
					target: "_blank",
					top: "48.7%",
					width: "60.7%",
				},
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/article/Threat-Horizon-2023-Security-at-a-tipping-point-Report",
					label: "Threat Horizon 2023: Security at a tipping point - Report",
					left: "18.8%",
					target: "_blank",
					top: "57.2%",
					width: "60.7%",
				},
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/article/Extinction-Level-Attacks-A-survival-guide-Report",
					label: "Extinction Level Attacks: A survival guide - Report",
					left: "18.8%",
					target: "_blank",
					top: "65.6%",
					width: "60.7%",
				},
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/article/continuous-supply-chain-assurance-report",
					label: "Continuous Supply Chain Assurance: Monitoring supplier security - Report",
					left: "18.8%",
					target: "_blank",
					top: "74.1%",
					width: "60.7%",
				},
				{
					height: "5.1%",
					href: "https://www.isflive.org/s/knowledge-library",
					label: "For more, please visit the ISF Library",
					left: "34.8%",
					target: "_blank",
					top: "84.1%",
					width: "28.5%",

				},
			]}
			/>,
			modalOverrides: {
				dismissStyle: {
					height: "4%",
					left: "78%",
					top: "9%",
					width: "2%",
				}
			},
			top: "35%",
			width: "8.3%",
		},
		{
			height: "21.6%",
			label: "Management and people - Access ISF products related to this key area",
			left: "41.3%",
			modal: <MappedImage imageURL="https://assets.swoogo.com/uploads/full/1411555-6168c89d33dde.png" links={[
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/article/Human-Centred-Security-Positively-influencing-security-beviour",
					label: "Human-Centred Security: Positively influencing security behaviour - Briefing Paper",
					left: "18.8%",
					target: "_blank",
					top: "21.1%",
					width: "60.7%",
				},
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/article/Becoming-a-next-generation-CISO",
					label: "Becoming a Next-Generation CISO - Briefing Paper",
					left: "18.8%",
					target: "_blank",
					top: "29.8%",
					width: "60.7%",
				},
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/article/Human-Centred-Security-Addressing-psychological-vulnerabilities",
					label: "Human-Centred Security: Addressing psychological vulnerabilities - Briefing Paper",
					left: "18.8%",
					target: "_blank",
					top: "38.2%",
					width: "60.7%",
				},
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/article/DOC-24113",
					label: "Building Tomorrow's Security Workforce - Briefing Paper",
					left: "18.8%",
					target: "_blank",
					top: "46.7%",
					width: "60.7%",
				},
				{
					height: "10.7%",
					href: "https://www.isflive.org/s/article/DOC-10973",
					label: "From Promoting Awareness to Embedding Behaviours: Secure by choice, not by chance - Report",
					left: "18.8%",
					target: "_blank",
					top: "55.1%",
					width: "60.7%",
				},
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/article/DOC-6311",
					label: "Engaging with the Board: Balancing cyber risk and reward - Report",
					left: "18.8%",
					target: "_blank",
					top: "66.8%",
					width: "60.7%",
				},
				{
					gameRule: "explore-books-people-more",
					height: "5.1%",
					href: "https://www.isflive.org/s/knowledge-library",
					label: "For more, please visit the ISF Library",
					left: "34.8%",
					target: "_blank",
					top: "77.2%",
					width: "28.5%",

				},
			]}
			/>,
			modalOverrides: {
				dismissStyle: {
					height: "4%",
					left: "77.5%",
					top: "15%",
					width: "2%",
				}
			},
			top: "35.5%",
			width: "8.2%",
		},
		{
			height: "21.3%",
			label: "Compliance, assurance and governance - Access ISF products related to this key area",
			title: "Access ISF products related to this key area",
			left: "50.3%",
			modal: <MappedImage imageURL="https://assets.swoogo.com/uploads/full/1411577-6168caa6a7f5e.png" links={[
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/article/Cyber-Insurance-Is-it-worth-the-risk",
					label: "Cyber Insurance: Is it worth the risk? Briefing Paper",
					left: "18.5%",
					target: "_blank",
					top: "18.4%",
					width: "60.7%",
				},
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/article/continuous-supply-chain-assurance-report",
					label: "Continuous Supply Chain Assurance: Monitoring supplier security - Report",
					left: "18.5%",
					target: "_blank",
					top: "26.9%",
					width: "60.7%",
				},
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/article/ISF-Benchmark?topicId=0TO0J0000009AOFWA2",
					label: "Benchmark",
					left: "18.5%",
					target: "_blank",
					top: "35.28%",
					width: "60.7%",
				},
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/article/Standard-of-Good-Practice-for-Information-Security-2020-PDF-Format",
					label: "Standard of Good Practice for Information Security 2020",
					left: "18.5%",
					target: "_blank",
					top: "43.8%",
					width: "60.7%",
				},
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/article/Legal-and-Regulatory-Implications-for-Information-Security",
					label: "Legal and Regulatory Implications for Information Security - Report",
					left: "18.5%",
					target: "_blank",
					top: "52%",
					width: "60.7%",
				},
				{
					height: "10.6%",
					href: "https://www.isflive.org/s/article/Establishing-a-business-focused-security-assurance-programme-Report",
					label: "Establishing a Business-Focused Security Assurance Programme: Confidence in controls – Report",
					left: "18.5%",
					target: "_blank",
					top: "60.6%",
					width: "60.7%",
				},
				{
					height: "7.5%",
					href: "https://www.isflive.org/s/article/DOC-24123",
					label: "Delivering an Effective Cyber Security Exercise - Report",
					left: "18.5%",
					target: "_blank",
					top: "72.4%",
					width: "60.7%",
				},
				{
					height: "5.1%",
					href: "https://www.isflive.org/s/knowledge-library",
					label: "For more, please visit the ISF Library",
					left: "34.8%",
					target: "_blank",
					top: "83.2%",
					width: "28.5%",

				},
			]}
			/>,
			modalOverrides: {
				dismissStyle: {
					height: "4%",
					left: "77.5%",
					top: "12%",
					width: "2%",
				}
			},
			top: "35.5%",
			width: "8.5%",
		},
		{

			height: "19.5%",
			label: "Risk management and technology - Access ISF products related to this key area",
			left: "59.2%",
			modal: <MappedImage imageURL="https://assets.swoogo.com/uploads/full/1411600-6168ccb3e196e.png" links={[
				{
					height: "6.5%",
					href: "https://www.isflive.org/s/article/Demystifying-Zero-Trust-Briefing-Paper",
					label: "Demystifying Zero Trust - Briefing Paper",
					left: "18.5%",
					target: "_blank",
					top: "12.5%",
					width: "60.7%",
				},
				{
					height: "6.5%",
					href: "https://www.isflive.org/s/article/Quantitative-Information-Risk-Assessment-QIRA-Methodology",
					label: "Quantitative Information Risk Assessment (QIRA) – Methodology",
					left: "18.5%",
					target: "_blank",
					top: "20%",
					width: "60.7%",
				},
				{
					height: "6.5%",
					href: "https://www.isflive.org/s/article/Securing-Containers-Keeping-pace-with-change-Briefing-paper",
					label: "Securing Containers: Keeping pace with change - Briefing Paper",
					left: "18.5%",
					target: "_blank",
					top: "27.5%",
					width: "60.7%",
				},
				{
					height: "6.5%",
					href: "https://www.isflive.org/s/article/Security-Architecture-Navigating-complexity-Report",
					label: "Security Architecture: Navigating complexity - Report",
					left: "18.5%",
					target: "_blank",
					top: "35%",
					width: "60.7%",
				},
				{
					height: "6.5%",
					href: "https://www.isflive.org/s/article/IRAM2-Web-App?topicId=0TO0J0000009AOBWA2",
					label: "Information Risk Assessment Methodology 2 WebApp",
					left: "18.5%",
					target: "_blank",
					top: "42.5%",
					width: "60.7%",
				},
				{
					height: "6.5%",
					href: "https://www.isflive.org/s/article/Deploying-Open-Source-Software-Challenges-and-Rewards-Briefing-Paper",
					label: "Deploying Open Source Software: Challenges and rewards - Briefing Paper",
					left: "18.5%",
					target: "_blank",
					top: "50%",
					width: "60.7%",
				},
				{
					height: "6.5%",
					href: "https://www.isflive.org/s/article/Using-Cloud-Services-Securely-Harnessing-core-controls-Report",
					label: "Using Cloud Services Securely: Harnessing core controls - Report",
					left: "18.5%",
					target: "_blank",
					top: "57.5%",
					width: "60.7%",
				},
				{
					height: "6.5%",
					href: "https://www.isflive.org/s/article/Demystifying-Artificial-Intelligence-in-Information-Security",
					label: "Demystifying Artificial Intelligence in Information Security - Briefing Paper",
					left: "18.5%",
					target: "_blank",
					top: "65%",
					width: "60.7%",
				},
				{
					height: "6.5%",
					href: "https://www.isflive.org/s/article/Securing-the-IoT-Taming-the-Connected-World-Briefing-paper",
					label: "Securing the IoT: Taming the connected world – Briefing Paper",
					left: "18.5%",
					target: "_blank",
					top: "72.5%",
					width: "60.7%",
				},
				{
					height: "6.5%",
					href: "https://www.isflive.org/s/article/Building-a-Successful-SOC-detect-earlier-respond-faster-Report-ed",
					label: "Building a Successful SOC: Detect earlier, respond faster - Report",
					left: "18.5%",
					target: "_blank",
					top: "80%",
					width: "60.7%",
				},
				{
					height: "5.1%",
					href: "https://www.isflive.org/s/knowledge-library",
					label: "For more, please visit the ISF Library",
					left: "34.8%",
					target: "_blank",
					top: "89.2%",
					width: "28.5%",

				},
			]}
			/>,
			modalOverrides: {
				dismissStyle: {
					height: "4%",
					left: "77.5%",
					top: "6.5%",
					width: "2%",
				}
			},
			top: "35.7%",
			width: "8.3%",
		},
	],
	name: "exploration-zone",
}
